import DataFactory from "./data_factories/data_factory";
import { PIE_CHART } from "../../constants/reports_constants";

export default class ChartGenerator {

    constructor(chartType, labelFunction, labelReducerFunction, valueFunction, filterFunction = null) {
        this._chartType = chartType;
        this._dataFactory = new DataFactory(labelFunction, labelReducerFunction, valueFunction);
        this._filterFunction = filterFunction;
    }

    isChartEnabled() {
        return true;
    }

    getChartType() {
        return this._chartType;
    }

    getChartData(matchingDevices) {
        // Apply filter if provided (filter function is a predicate for Array.filter())
        const filteredDevices = this._filterFunction ? matchingDevices.filter(this._filterFunction) : matchingDevices;
        return this._dataFactory.getData(filteredDevices);
    }

    getChartLabels(matchingDevices) {
        // Apply filter if provided (filter function is a predicate for Array.filter())
        const filteredDevices = this._filterFunction ? matchingDevices.filter(this._filterFunction) : matchingDevices;
        return this._dataFactory.getLabels(filteredDevices);
    }

    getShowLegend() {
        return this.getChartType() === PIE_CHART;
    }

}